<div class="mb-3">
  <div>

    <h1 class="pb-2 border-bottom fw-light" i18n>Rechnungen für Verkäufe erstellen</h1>

    <div class="mt-3">
      <app-invoice-order-search (searchCriteria)="search($event)"></app-invoice-order-search>
    </div>

    @if (profile?.isActive) {
      <div class="row mb-3">
        <div class="col-sm-12" i18n>Selektieren Sie in der Spalte "Auswahl" alle Verkäufe, die in die Rechnung(en) einfließen
        sollen. Klicken Sie
        anschließend auf "Rechnungen erstellen"</div>
      </div>
    }

    <kendo-grid [data]="list.gridData" [pageable]="true" [skip]="list.state.skip" [pageSize]="list.state.pageSize"
      [sortable]="true" [sort]="list.state.sort"
      (pageChange)="list.onPageChange($event)" (sortChange)="list.onSortChange($event)"
      [reorderable]="true" [resizable]="true"
      [selectable]="true" (selectedKeysChange)="selectionChange($event)" kendoGridSelectBy="id"
      [selectedKeys]="selectedOrders">
      <ng-template kendoGridNoRecordsTemplate>
        <app-grid-no-records [loading]="list.loading" loadingText="Aufträge werden geladen…" i18n-loadingText></app-grid-no-records>
      </ng-template>
      <ng-template kendoGridToolbarTemplate>
        <button kendoGridPDFCommand icon="file-pdf" i18n>PDF-Export</button>
        @if (profile?.customer.isRetailer) {
          <button [asyncClick]="onCreateInvoices.bind(this)" [disabled]="createBtn.disabled || !selectedOrders?.length" #createBtn="asyncClick" class="btn btn-primary ms-auto" type="button" i18n>
            @if (createBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
            Rechnungen erstellen
          </button>
        }
      </ng-template>
      <kendo-grid-column field="buyerCustomerFullName" [sortable]="false" i18n-title title="Kunde"></kendo-grid-column>
      <kendo-grid-column field="orderNumber" i18n-title title="Auftragsnummer" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="orderDateTime" format="{0:g}" i18n-title title="Datum / Uhrzeit"></kendo-grid-column>
      <kendo-grid-column field="grossPrice" [sortable]="false" i18n-title title="Gesamtpreis" [width]="100">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.grossPrice | currency: dataItem.currency }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="discount" [sortable]="false" i18n-title title="Rabatt" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.discount | currency: dataItem.currency }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-checkbox-column [showSelectAll]="true" i18n-title title="Auswahl" [width]="120"></kendo-grid-checkbox-column>

      <kendo-grid-pdf appGridPdf fileName="Rechnungserstellung.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [scale]="0.75">
        <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
        <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
          <app-pdf-page title="Rechnungserstellung" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
        </ng-template>
      </kendo-grid-pdf>
    </kendo-grid>
  </div>
</div>